// Redirect page: voice rooms moved to meetings.
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

export function RoomRedirect() {
  const { conversationId: oldId } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // We don't have a mapping from conversationId to meetingId on the client,
    // so we just go home and let the user start a new meeting.
    navigate('/');
  }, [navigate]);

  return (
    <div className="page">
      <div className="room-center room-card">
        <h2>Voice rooms moved.</h2>
        <p>Start a meeting from the project page.</p>
        <button type="button" className="btn btn-primary" onClick={() => navigate('/')}>
          Go home
        </button>
      </div>
    </div>
  );
}
